export default __webpack_public_path__ + "static/media/Mask of Bestial Rage.eac2db08.jpg";